import './pages/funnel'

// throw new Error('Bad entrypoint. Check ./config-overrides.js for a list of routes')
